import { application } from "./application"

import Clipboard from "@stimulus-components/clipboard"
application.register("clipboard", Clipboard)

import ReadMore from "@stimulus-components/read-more"
application.register("read-more", ReadMore)
